import { UserAdministrationInfo } from '../common/interfaces/common.interface';
import api, { ADMINISTRATION_INFO_PATH } from './api';

export const getUserAdministrationInfo = async (): Promise<UserAdministrationInfo> => {
  const response = await api.get(ADMINISTRATION_INFO_PATH);

  return response.data.results;
};
